import React from 'react'

import BlogsList from '../components/Blogs/BlogsList.component'
import Footer1 from '../components/Footers/Footer1.component'
import Header from '../components/Headers/Header.component'

import featuredImg from "../assets/images/blog-detail/img-01.jpg";
import ReactImageFallback from 'react-image-fallback';
import defaultImg from "../assets/images/default_featured_img.png";
import defaultUser from "../assets/images/default_profile_pic.jpg";
import { useEffect } from 'react';

export default function BlogPost() {


    return (
        <>
            <Header />

            <main>
                {/* <!-- SERVICES START --> */}
                <section className="bds-main-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="bds-blogbanner">
                                    <div className="bds-helpsuppotcontainer">
                                        <div className="bds-tehelpop">
                                            <ul className="bds-tags">
                                                <li><h5><a href="freelancer-list.html">Mobile</a></h5></li>
                                                <li><h5><a href="freelancer-list.html">Entertainment</a></h5></li>
                                            </ul>
                                            <h3>Top 10 tips to build your professional team to face any situation at any time with confidence</h3>
                                            <ul className="bds-blogviewdates">
                                                <li><span><i className="icon-calendar"></i> Jun 27, 2020</span></li>
                                                <li><span><i className="icon-message-square"></i> 127,558</span></li>
                                                <li><span><i className="icon-eye"></i> 856,854</span></li>
                                            </ul>
                                        </div>
                                        <div className="bds-bloglistingicons">
                                            <h5>Share this post</h5>
                                            <ul className="bds-socailmedia">
                                                <li><a className="bds-facebook" href="https://www.facebook.com/" target="_blank"><i className="fab fa-facebook-f"></i></a></li>
                                                <li><a className="bds-twitter" href="https://twitter.com/" target="_blank"><i className="fab fa-twitter"></i></a></li>
                                                <li><a className="bds-linkedin" href="https://www.linkedin.com/" target="_blank"><i className="fab fa-linkedin-in"></i></a></li>
                                                <li><a className="bds-twitch" href="https://www.twitch.tv/" target="_blank"><i className="fab fa-twitch"></i></a></li>
                                                <li><a className="bds-dribbble" href="https://dribbble.com/" target="_blank"><i className="fab fa-dribbble"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="bds-blogbanner__img">
                                        <ReactImageFallback 
                                            src={featuredImg}
                                            initialImage={defaultImg} 
                                            fallbackImage={defaultImg}
                                            alt="Image Description" 
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="bds-box">
                                    <div className="bds-main-title-holder">
                                        <div className="bds-main-description">
                                            <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi id est laborum et dolorum fuga rerum faciliste.</p>
                                            <p>Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam etmiaut officiis debitis auit rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint etemolestiae nocusandae Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aeut perferendis doloribus asperiores repellate.</p>
                                        </div>
                                    </div>
                                    <div className="bds-maintitle text-center">
                                        <blockquote><h3>“ Challenges are what make life interesting and overcoming them is what makes life meaningful. ”</h3></blockquote>
                                    </div>
                                    <div className="bds-main-description pt-0">
                                        <p>Dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.</p>
                                        <p>Fugiat nulla pariatur excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque udantium totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt plicabon Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magniolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qolorem ipsum quia dolor sit amet ectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.</p>
                                        <p>Consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium</p>
                                    </div>
                                </div>
                                <div className="bds-box">
                                    <div className="bds-blogtags">
                                        <div className="bds-tagtittle">
                                            <span>Tags:</span>
                                        </div>
                                        <ul className="bds-tags_links">
                                            <li>
                                                <a href="blog.html" className="bds-blog-tags">INDESIGN</a>
                                            </li>
                                            <li>
                                                <a href="blog.html" className="bds-blog-tags">TYPING TUTOR</a>
                                            </li>
                                            <li>
                                                <a href="blog.html" className="bds-blog-tags bds-blog-tags-active">TYPING MASTER</a>
                                            </li>
                                            <li>
                                                <a href="blog.html" className="bds-blog-tags">E-COMMERCE</a>
                                            </li>
                                            <li>
                                                <a href="blog.html" className="bds-blog-tags">DATA VALIDATION</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" className="bds-blog-showmore">SHOW MORE</a>
                                            </li>
                                            <li className="bds-button-disapear">
                                                <a href="blog.html" className="bds-blog-tags">ONLINE SEO</a>
                                            </li>
                                            <li className="bds-button-disapear">
                                                <a href="blog.html" className="bds-blog-tags">CONTENT WRITER</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="bds-box">
                                    <div className="bds-blogcomments">
                                        <div className="bds-maintitle">
                                            <h3>12 Comments</h3>
                                        </div>
                                        <div className="bds-addcomment">
                                            <div className="bds-blogimg">
                                                <figure>
                                                    <ReactImageFallback 
                                                        src="images/blog-detail/comment/img-01.jpg" 
                                                        initialImage={defaultUser}
                                                        fallbackImage={defaultUser}
                                                        alt="Image Description" 
                                                    />
                                                </figure>
                                                <div className="bds-blogcmntinfo">
                                                    <div className="bds-blogcmntinfonames">
                                                        <div className="bds-icondetails">
                                                            <span>02 sec ago</span>
                                                        </div>
                                                        <div className="bds-comentinfodetail">
                                                            <a href="blog-detail.html#">
                                                                <h4>Darren Mason</h4>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <a href="blog-detail.html#bds-replyformholder" className="bds-btn-solid">Reply</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="bds-main-description">
                                                <p>Dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris neim utnae aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate veliten essemae cillum dolore ut aliquip ex ea commodo consequat.</p>
                                            </div>
                                        </div>
                                        <div className="bds-addcomment">
                                            <div className="bds-blogimg">
                                                <figure>
                                                <ReactImageFallback 
                                                        src="images/blog-detail/comment/img-01.jpg" 
                                                        initialImage={defaultUser}
                                                        fallbackImage={defaultUser}
                                                        alt="Image Description" 
                                                    />
                                                </figure>
                                                <div className="bds-blogcmntinfo">
                                                    <div className="bds-blogcmntinfonames">
                                                        <div className="bds-icondetails">
                                                            <span>10 min ago</span>
                                                        </div>
                                                        <div className="bds-comentinfodetail">
                                                            <a href="blog-detail.html#">
                                                                <h4>Patsy Arnold</h4>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <a href="blog-detail.html#bds-replyformholder" className="bds-btn-solid">Reply</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="bds-main-description">
                                                <p>Dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris neim utnae aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate veliten essemae cillum dolore ut aliquip ex ea commodo consequat.</p>
                                            </div>
                                        </div>
                                        <div className="bds-blogcommentsholderchild">
                                            <div className="bds-addcomment">
                                                <div className="bds-blogimg">
                                                    <figure>
                                                    <ReactImageFallback 
                                                        src="images/blog-detail/comment/img-01.jpg" 
                                                        initialImage={defaultUser}
                                                        fallbackImage={defaultUser}
                                                        alt="Image Description" 
                                                    />
                                                    </figure>
                                                    <div className="bds-blogcmntinfo">
                                                        <div className="bds-blogcmntinfonames">
                                                            <div className="bds-icondetails">
                                                                <span>03 min ago</span>
                                                            </div>
                                                            <div className="bds-comentinfodetail">
                                                                <a href="blog-detail.html#">
                                                                    <h4>Ross Anderson</h4>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <a href="blog-detail.html#bds-replyformholder" className="bds-btn-solid">Reply</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="bds-main-description">
                                                    <p>Dolore magna aliqua. Ut enim ad minim veniam, quistan nostrud exercitation ullamco laboris neim ut aliquip ex ea commodo consequat. Duis aute irure dolor reprehendrit in voluptate veliten esse cillum dolore ut aliquip.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="bds-addcomment">
                                            <div className="bds-blogimg">
                                                <figure>
                                                <ReactImageFallback 
                                                        src="images/blog-detail/comment/img-01.jpg" 
                                                        initialImage={defaultUser}
                                                        fallbackImage={defaultUser}
                                                        alt="Image Description" 
                                                    />
                                                </figure>
                                                <div className="bds-blogcmntinfo">
                                                    <div className="bds-blogcmntinfonames">
                                                        <div className="bds-icondetails">
                                                            <span>01 min ago</span>
                                                        </div>
                                                        <div className="bds-comentinfodetail">
                                                            <a href="blog-detail.html#">
                                                                <h4>Bradley Gallagher</h4>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <a href="blog-detail.html#bds-replyformholder" className="bds-btn-solid">Reply</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="bds-main-description">
                                                <p>Dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris neim utnae aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate veliten essemae cillum dolore ut aliquip ex ea commodo consequat.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="bds-box" id="bds-replyformholder">
                                    <div className="bds-maintitle">
                                        <h3>Add your review</h3>
                                    </div>
                                    <form className="bds-themeform" id="bds-replyform">
                                        <fieldset>
                                            <div className="bds-themeform__wrap">
                                                <div className="form-group  form-group-half">
                                                    <div className="bds-placeholderholder">
                                                        <input type="text" className="form-control bds-themeinput" required="required" />
                                                        <div className="bds-placeholder">
                                                            <span>Your full name</span>
                                                            <em>*</em>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group  form-group-half">
                                                    <div className="bds-placeholderholder">
                                                        <input type="email" className="form-control bds-themeinput" required="required" />
                                                        <div className="bds-placeholder">
                                                            <span>Your email</span>
                                                            <em>*</em>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="bds-placeholderholder">
                                                        <input type="text" className="form-control bds-themeinput" required="required" />
                                                        <div className="bds-placeholder">
                                                            <span>Add subject</span>
                                                            <em>*</em>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="bds-placeholderholder theme-rounded-25">
                                                        <textarea name="Description" className="form-control bds-themeinput" required="required"></textarea>
                                                        <div className="bds-placeholder">
                                                            <span>Enter description</span>
                                                            <em>*</em>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="bds-terms">
                                                        <div className="bds-form-checkbox">
                                                            <input className="form-check-input" type="checkbox" value="" id="bds-check" />
                                                            <label className="form-check-label" for="bds-check">
                                                                <span> I have read and agree to all <a href="about-us.html">Terms &amp; conditions</a></span>
                                                            </label>
                                                        </div>
                                                        <button type="submit" name="submit" className="bds-btn-solid-lg">Submit<i className="icon-arrow-right"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <aside>
                                    <div className="bds-asideholder">
                                        <div className="bds-asidebox">
                                            <div className="bds-blogprofileuser">
                                                <figure>
                                                <ReactImageFallback 
                                                        src="images/blog-detail/comment/img-01.jpg" 
                                                        initialImage={defaultUser}
                                                        fallbackImage={defaultUser}
                                                        alt="Image Description" 
                                                    />
                                                </figure>
                                                <div className="bds-profilrtitle">
                                                    <h6><a href="blog.html">Blog author</a></h6>
                                                    <h5><a href="blog.html">Milan throckmorton</a></h5>
                                                </div>
                                                <ul className="bds-socailmedia">
                                                    <li><a className="bds-facebook" href="https://www.facebook.com/" target="_blank"><i className="fab fa-facebook-f"></i></a></li>
                                                    <li><a className="bds-twitter" href="https://twitter.com/" target="_blank"><i className="fab fa-twitter"></i></a></li>
                                                    <li><a className="bds-linkedin" href="https://www.linkedin.com/" target="_blank"><i className="fab fa-linkedin-in"></i></a></li>
                                                    <li><a className="bds-twitch" href="https://www.twitch.tv/" target="_blank"><i className="fab fa-twitch"></i></a></li>
                                                    <li><a className="bds-dribbble" href="https://dribbble.com/" target="_blank"><i className="fab fa-dribbble"></i></a></li>
                                                </ul>
                                                <div className="bds-blogprofileuser__description">
                                                    <p>At vero eos et accusamus et iusto odio dignissie corrupti quos dolores et quas molestias excepo officia deserunt mollitia animi id est laborum et dolorum fuga rerum faciliste.</p>
                                                </div>
                                                <div className="bds-btnarea">
                                                    <a href="blog.html" className="bds-btn-solid-lg">View All Posts</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bds-asideholder">
                                        <div className="bds-asideboxv2">
                                            <div className="bds-sidetitle">
                                                <h5>Search</h5>
                                            </div>
                                            <div className="bds-sidecontent">
                                                <div className="bds-inputiconbtn">
                                                    <div className="bds-placeholderholder">
                                                        <input type="text" className="form-control bds-themeinput" required="required" />
                                                        <div className="bds-placeholder">
                                                            <span>Search here</span>
                                                            <em>*</em>
                                                        </div>
                                                    </div>
                                                    <a href="blog-detail.html#" className="bds-btn-solid-sm"><i className="icon-search"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="bds-asideboxv2">
                                            <div className="bds-sidetitle">
                                                <h5>Categories</h5>
                                            </div>
                                            <ul className="bds-exploremore" id="bds-exploremore" data-readmore="" aria-expanded="false" style={{ maxHeight: "none", height: "205px" }}>
                                                <li>
                                                    <span>E-commerce &amp; CRM</span>
                                                    <em>74875</em>
                                                </li>
                                                <li>
                                                    <span>Compose &amp; Edit</span>
                                                    <em>18599</em>
                                                </li>
                                                <li>
                                                    <span>IT &amp; Project Management</span>
                                                    <em>3398</em>
                                                </li>
                                                <li>
                                                    <span>CTI Providers</span>
                                                    <em>4339</em>
                                                </li>
                                                <li>
                                                    <span>Collaboration</span>
                                                    <em>50963</em>
                                                </li>
                                                <li>
                                                    <span>Built By Zendesk</span>
                                                    <em>16415</em>
                                                </li>
                                                <li>
                                                    <span>Compose &amp; Edit</span>
                                                    <em>50963</em>
                                                </li>
                                                <li>
                                                    <span>E-commerce &amp; CRM</span>
                                                    <em>18599</em>
                                                </li>
                                                <li>
                                                    <span>CTI Providers</span>
                                                    <em>74875</em>
                                                </li>
                                            </ul><a href="javascript:void(0);" className="bds-readmorebtnv2" data-readmore-toggle="bds-exploremore" aria-controls="bds-exploremore">Show All</a>
                                        </div>
                                        <div className="bds-asideboxv2">
                                            <div className="bds-sidetitle">
                                                <h5>Archives</h5>
                                            </div>
                                            <div className="bds-sidecontent">
                                                <ul className="bds-explorearchives">
                                                    <li><span>2020 - 2019</span></li>
                                                    <li><span>2016 - 2015</span></li>
                                                    <li><span>2019 - 2018</span></li>
                                                    <li><span>2015 - 2014</span></li>
                                                    <li><span>2018 - 2017</span></li>
                                                    <li><span>2014 - 2013</span></li>
                                                    <li><span>2017 - 2016</span></li>
                                                    <li><span>2013 - 2012</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </aside>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- SERVICES END --> */}
            </main>

            <Footer1 />
        </>
    )
}
